<lib-menu-global />
<lib-navigation [logoUrl]="logoUrl()" />
<lib-curved-box
  [curve]="brand.isYallo() ? 'bottom' : 'none'"
  [horizontalLines]="brand.isChmobile() ? 'bottom' : 'none'"
  [showOverflow]="true"
  [ngClass]="{ '[&_.curved-box]:-mt-16 [&_.curved-box]:pt-16': brand.isChmobile() }"
>
  <div class="container pt-10 px-5 flex justify-center">
    <div class="max-w-3xl text-center">
      <h1 class="text-2xl md:text-6xl">{{ ['support', 'title'] | translate }}</h1>
      <h2 class="text-md mb-10">
        {{ ['support', 'sub_title'] | translate }}
      </h2>
      <app-search />
    </div>
  </div>

  @if (brand.isChmobile()) {
    <div class="flex items-center w-full h-24 justify-stretch">
      <div class="bg-white h-px w-24"></div>
      <div class="px-2"><lib-svg class="white medium" svg="swiss" /></div>
      <div class="bg-white h-px flex-1"></div>
      <div class="px-2"><lib-svg class="white large" svg="matterhorn" /></div>
      <div class="bg-white h-px w-24"></div>
    </div>
  }
</lib-curved-box>
<main class="container my-6 px-5 xl:px-56">
  <router-outlet />
</main>
<lib-footer />
